module.exports = __webpack_public_path__ + "img/youtube-logo.856ca87.png";